import { c as _c } from "react/compiler-runtime";
import { Fade } from 'transitions-kit';
import { Filters } from './filters';
import css from './search.module.scss';
interface Props {
  search: string;
  onSearch: (value: string) => void;
}
export function Search(t0) {
  const $ = _c(17);
  const {
    search,
    onSearch
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Feature flags</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSearch) {
    t2 = e => onSearch(e.target.value);
    $[1] = onSearch;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== search || $[4] !== t2) {
    t3 = <input id="search" value={search} autoComplete="off" onChange={t2} placeholder="Search by experiment key" className={css.search} />;
    $[3] = search;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !!search;
  let t5;
  if ($[6] !== onSearch) {
    t5 = <button className={css.reset} onClick={() => onSearch("")}>✕</button>;
    $[6] = onSearch;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <Fade in={t4}>{t5}</Fade>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Filters />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <div className={css.controls}>{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t3 || $[15] !== t8) {
    t9 = <>{t1}<div className={css.wrapper}>{t3}{t8}</div></>;
    $[14] = t3;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}